import {
  USER_GET,
  USER_DELETE,
  USER_PROFILE,
  USER_UPDATE,
  USER_SEND_WELCOME
} from '../actions/users'
import apiCall from './call'

const model = 'users'

const state = {
  //
}

const getters = {
  //
}

const actions = {
  [USER_GET]: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + userId })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [USER_DELETE]: ({ commit, dispatch }, userId) => {
    let users = { ids: [userId] }
    return new Promise((resolve, reject) => {
      apiCall({ url: model, data: users, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [USER_PROFILE]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/profile' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [USER_UPDATE]: ({ commit, dispatch }, update) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + update.endpoint, data: update.data, method: 'PUT' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [USER_SEND_WELCOME]: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + userId + '/sendwelcome', method: 'POST' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js